<div id="cta-outer" [class]="ctaClass" *ngIf="!buttonOnly">
  <div [hidden]="showCustomTemplate">
    <div class="cta-title text-white mb-3">
      <fa-icon *ngIf="titleIcons" class="text-success" [icon]="faTree" size="xs"></fa-icon>
      {{title}}
      <fa-icon *ngIf="titleIcons" class="text-success" [icon]="faTree" size="xs"></fa-icon>
    </div>
    <ul class="cta-bullet-wrapper ml-10 mb-10" *ngIf="bulletPoints.length">
      <li class="cta-list-item" *ngFor="let bulletPoint of bulletPoints">
        {{ bulletPoint }}
      </li>
    </ul>
    <div *ngIf="textPoints.length" class="ml-10 mb-0 text-points">
      <div *ngFor="let textPoint of textPoints">
        {{ textPoint }}
      </div>
    </div>
    <button
      *ngIf="!noButton"
      (click)="navigate()"
      class="cta-button mt-4 btn btn-primary btn-block btn-sm m-0 pointer d-flex flex-row"
    >
      <div>
        {{ cta }}
      </div>
    </button>
    <div *ngIf="subPoints.length" class="ml-5 mb-0 sub-points">
      <div *ngFor="let subPoint of subPoints">
        {{ subPoint }}
      </div>
    </div>
  </div>
  <div #customTemplate>
    <ng-content></ng-content>
  </div>
</div>

<div *ngIf="buttonOnly">
  <button
    (click)="navigate()"
    class="cta-button mt-4 btn btn-primary btn-block btn-sm m-0 pointer d-flex flex-row"
  >
    <div>
      {{ cta }}
    </div>
  </button>
</div>
